_ = require('underscore');
module.exports = {
    "template": function(obj) {
var __t, __p = '';
__p += '\n    <div class=\'bunsen-modal ' +
((__t = ( obj.classNames.modal )) == null ? '' : __t) +
' pre-animation\'>\n        <div class=\'bunsen-modal-scrim ' +
((__t = ( obj.classNames.scrim )) == null ? '' : __t) +
'\'></div>\n        <div class=\'bunsen-modal-body ' +
((__t = ( obj.classNames.body )) == null ? '' : __t) +
'\'>\n            <div class=\'bunsen-modal-header ' +
((__t = ( obj.classNames.header )) == null ? '' : __t) +
'\'>\n                <span data-model-bind=\'visible: model.title, text: model.title\'></span>\n                <span data-model-bind=\'visible: model.titleHTML, html: model.titleHTML\'></span>\n                <i data-model-bind=\'visible: model.showClose\' class="bunsen-modal-close ' +
((__t = ( obj.classNames.close )) == null ? '' : __t) +
' bunsen-icon bunsen-icon-close" aria-label="Close"></i>\n            </div>\n            <div class=\'bunsen-modal-content ' +
((__t = ( obj.classNames.content )) == null ? '' : __t) +
'\'></div>\n            <div class=\'bunsen-modal-buttons ' +
((__t = ( obj.classNames.buttons )) == null ? '' : __t) +
' text-' +
((__t = ( obj.buttonsAlignment )) == null ? '' : __t) +
'\' data-append=\'buttons\'></div>\n        </div>\n    </div>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/components/BunsenModal/BunsenModal-template.html
// module id = 716
// module chunks = 4 6 7 8 9 13 17